const state = {
  data: {},
  id: null,
  owner_id: undefined,
  owner_type: undefined,
  provider_id: undefined,
  service_product_id: undefined,
  subject_id: undefined,
  subject_type: undefined,
  template_page_id: undefined,
}

export const requiredFields = [
  { key: 'owner_id' },
  { key: 'owner_type' },
  { key: 'subject_id' },
  { key: 'subject_type' },
]

export default state
